import React from 'react'
import Media from 'sb-media'
import { FormattedMessage, FormattedHTMLMessage } from 'sb-react-intl'

import Logo from 'components/ui/Logo/Logo'
import Center from 'components/layout/Center/Center'

import messages from './messages'
import s from './500.scss'

// resolve picture x2 x3
import mobileImage from './images/mobile-500.jpg'
// resolve picture x2
import desktopImage from './images/desktop-500.jpg'


const Page500 = ({ err }) => {
  console.error(err)

  let message

  if (typeof err === 'string') {
    message = err
  }
  else {
    try {
      message = `${err.message}\n${err.stack}`
    }
    catch (err) {
      message = err
    }
  }

  const content = (
    <div className={s.content}>
      <Logo className={s.logo} dark />
      <FormattedHTMLMessage className={s.title} tag="div" {...messages.title} />
      <FormattedMessage className={s.subTitle} tag="div" {...messages.subTitle} />
      <Media mobile>
        {
          (isMobile) => (
            <img
              className={s.image}
              {...(isMobile ? mobileImage : desktopImage)}
              alt=""
            />
          )
        }
      </Media>
      <div
        style={{ display: 'none' }}
        id="500-errorText"
        dangerouslySetInnerHTML={{ __html: message || 'Error: unknown' }}
      />
    </div>
  )

  return (
    <Media mobile>
      {
        (isMobile) => isMobile ? (
          content
        ) : (
          <Center>
            {content}
          </Center>
        )
      }
    </Media>
  )
}


export default Page500
